import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import RowConfigRow from "../row_config/RowConfigRow";
import LengthRows from "../row_config/LengthRows";
import PositionRows from "../row_config/PositionRows";
import ExceptionMessage from "../common_elements/ExceptionMessage";
import ModuleOverview from "../row_config/ModuleOverview";
import {moduleUiDisplayChanged, moduleUiChanged} from "../../store/configuratorStateSlice";
import PropTypes from "prop-types";

const RowConfigStep = (props) => {

    const perModuleAttributes = props.attributes;
    const perModuleSelections = props.selections;
    const displayOverview = useSelector(state => state.configuratorStateReducer.uiState.displayModuleOverview)
    const dispatch = useDispatch();
    const [messages, setMessages] = useState([]);
    const [left, setLeft] = useState(0);

    const reorderForVerticalTable = (data) => {
        // this function reorders data so we can use vertical rows
        // it will take and array of object hashes and combine all properties that match
        // between objects, ex [{ length: 4, quantity: 2}, { length: 5, quantity: 1}] will become
        // {length: [4, 5], quantity: [2,1] }
        const reordered = {};

        if (data) {

            const attributes = Object.keys(data[0]);

            attributes.forEach((key) => {
                const row = data.map((m) => m[key]);
                // reuse key for passing to ui
                reordered[key] = row;
            })
        }

        return reordered;
    };

    const orderModuleOptionsBySku = (a,b) => {
        if ( a.sku_order > b.sku_order) {
            return 1
        }

        if(a.sku_order < b.sku_order) {
            return -1
        }
        return 0
    };


    const reorderModuleOptions = (moduleOptions) => {
        const mo = Object.assign([], moduleOptions);
        const options = mo.sort(orderModuleOptionsBySku).map((d) => d.name);
        const reordered = [];
        // for each module generate a selection
        perModuleSelections.forEach((d) => {
            options.forEach((opt) => {
                if (!reordered[opt]) {
                    reordered[opt] = []
                }
                reordered[opt].push(mo.find((dd) => dd.name == opt))
            });

        });
        return reordered;
    };

    const exceptionMessage = () => {
        if(messages.length == 0) {
            return
        }

        return <ExceptionMessage message={messages} posLeft={left} />
    }

    const toggleUI = (e) => {
        e.preventDefault();
        if(props.side) {
            dispatch(moduleUiChanged({id: props.side, value: true}))
        } else if(props.isElement){
            dispatch(moduleUiChanged({id: props.elementId, value: true}))
        } else {
            dispatch(moduleUiChanged({id: 'main', value: true}))
        }
    }

    const styles = {
        headerStyle: {
            backgroundColor: '#e5e5e5',
            textAlign: 'right',
            textTransform: 'capitalize'
        },
        bodyStyle: {
            textAlign: 'center',
        },
        tableStyle: {
            background: 'none',
        },
        moduleTitleStyle: {
            backgroundColor: '#c2c2c2',
            textAlign: 'center',
            marginBottom: '15px'
        },
        overviewButtonStyle: {
            padding: '10px 16px'
        }
    };

    const displayContent = () => {
        let showOverview;
        let headerStyle = null;
        if(props.side){
            const showForSide = displayOverview[props.side];
            showOverview = typeof showForSide !== 'undefined' ? showForSide : true;
            headerStyle = {padding: '5px'}
        } else if(props.isElement){
            showOverview = typeof displayOverview[props.elementId] !== 'undefined' ? displayOverview[props.elementId] : true;
        } else {
            showOverview = typeof displayOverview['main'] !== 'undefined' ? displayOverview['main'] : true;
        }
        if(showOverview){
            return <ModuleOverview styles={styles} side={props.side} elementId={props.elementId} isElement={props.isElement}/>
        } else {
            return(
                <div className="row-config-step">
                    <div className="row" style={{margin: 0}}>
                        <div className="small-12 medium-3 columns no-padding" style={{padding: '0'}}>
                            <h3 style={headerStyle}>Module Options</h3>
                            <button onClick={(e) => toggleUI(e)} className="button left-chevron configurator-action-button" style={{marginTop: '15px'}}> Row Summary </button>
                        </div>
                        <div className="small-12 medium-9 columns">
                            <fieldset>
                                <table className="module-option-table">
                                    <tbody>
                                    <PositionRows data={data.position}/>
                                    <LengthRows data={data.length} />
                                    {rows}
                                    </tbody>
                                </table>
                            </fieldset>
                        </div>
                    </div>
                </div>
            )
        }
    };

    // check if null or empty object
    if (!perModuleSelections || perModuleSelections.length == 0 || perModuleAttributes.length == 0 || Object.keys(perModuleSelections).length === 0 && perModuleSelections.constructor === Object) {
        return null;
    }


    // const sorted = quoteItemModules.sort(sortByPosition);
    const data = reorderForVerticalTable(perModuleSelections);
    let rows;

    if (data && perModuleAttributes) {
        const option_data =  reorderModuleOptions(perModuleAttributes);
        const keys = Object.keys(option_data);
        const dataAsArray = keys.map((k) => option_data[k]);
        const side = props.side ? props.side : null;
        const elementId = props.isElement ? props.elementId : null;
        rows = dataAsArray.map((d, i) => <RowConfigRow key={'row-config-' + i} rowData={d} onBlur={() => setMessages([])} setLeft={(posX) => setLeft(posX)} setMessage={(message) => setMessages(message)} moduleData={perModuleSelections} side={side} elementId={elementId} isElement={props.isElement}/>);
    } else {
        rows = <div></div>;
    }

    // each module looks like { length:, position:, quantity:, component_options:{} }
    // component options is dynamic, the other attributes will always display first
    return (
        <div style={{position: 'relative'}}>
            <div className="configurator-step" onMouseLeave={() => setMessages([])}>
                { displayContent() }
            </div>
            { exceptionMessage() }
        </div>
    )

};

RowConfigStep.props = {
    selections: PropTypes.array.isRequired,
    attributes: PropTypes.array.isRequired,
    side: PropTypes.string,
    elementId: PropTypes.number
}

export default RowConfigStep;